import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthModuleModule } from './auth-module/auth-module.module';
import { PagesLayoutModule } from './layout/pages-layout/pages-layout.module';
import { HttpClientModule } from '@angular/common/http';
import { LoginModule } from './auth-module/login/login.module';
import { AlertDialogModule } from './utils/alert-dialog/alert-dialog.module';
import { LayoutModule } from './layout/layout/layout.module';
import { SettingsSidenavModule } from './layout/pages-layout/nomenclatoare/settings-sidenav/settings-sidenav.module';
import { AdministrationModule } from './layout/pages-layout/nomenclatoare/administration/administration.module';
import { CetateanModule } from './layout/pages-layout/nomenclatoare/cetatean/cetatean.module';
import { GalleryModule } from './layout/pages-layout/nomenclatoare/gallery/gallery.module';
import { httpInterceptorProviders } from './interceptors';
import { ApplicationModule } from './layout/pages-layout/nomenclatoare/aplication/application.module';
import { LogoutComponent } from './logout/logout.component';
import { ClientsModule } from './layout/pages-layout/nomenclatoare/clients/clients.module';
import { BulevartModule } from './layout/pages-layout/nomenclatoare/bulevart/bulevart-galerie/bulevart.module';
import { BulevartSettingsModule } from './layout/pages-layout/nomenclatoare/bulevart/bulevart-settings/bulevart-settings.module';
import { InstitutiiModule } from './layout/pages-layout/nomenclatoare/institutii/institutii.module';
import { GhiseulUnicModule } from './layout/pages-layout/nomenclatoare/ghiseul-unic/ghiseul-unic.module';
import { DatePipe } from '@angular/common';
import { registerLocaleData } from '@angular/common';
import localeRo from '@angular/common/locales/ro';

registerLocaleData(localeRo);

@NgModule({
    declarations: [AppComponent, LogoutComponent],
    imports: [
        HttpClientModule,
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        LoginModule,
        AuthModuleModule,
        PagesLayoutModule,
        AlertDialogModule,
        LayoutModule,
        SettingsSidenavModule,
        AdministrationModule,
        ClientsModule,
        CetateanModule,
        GalleryModule,
        ApplicationModule,
        BulevartModule,
        BulevartSettingsModule,
        GhiseulUnicModule,
        InstitutiiModule
    ],
    providers: [
        httpInterceptorProviders,
        DatePipe // Add DatePipe here
    ],
    bootstrap: [AppComponent],
})
export class AppModule { }
